module.exports = __webpack_public_path__ + "img/icon6.2bc3a1fd.png";